"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDelaySubscriptionErrorResponse = exports.Name = exports.DelaySubscriptionFailedEvent = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'delay-subscription-failed';
const DelaySubscriptionFailedEvent = exports.DelaySubscriptionFailedEvent = Name;
const isDelaySubscriptionErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isDelaySubscriptionErrorResponse = isDelaySubscriptionErrorResponse;
